import { render, staticRenderFns } from "./TaskComments.vue?vue&type=template&id=088d922a&scoped=true"
import script from "./TaskComments.vue?vue&type=script&lang=js"
export * from "./TaskComments.vue?vue&type=script&lang=js"
import style0 from "./TaskComments.scss?vue&type=style&index=0&id=088d922a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088d922a",
  null
  
)

export default component.exports